<script lang="ts">
  import Image from '../Image.svelte';
  export let publisherLogo: string;
  export let publisherName: string;
</script>

<div class="publisher-card">
  <div class="publisher-logo">
    <Image src={publisherLogo} alt={publisherName} priority={true} />
  </div>
  <h5 class="publisher-name">@{publisherName}</h5>
</div>

<style>
  .publisher-card {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .publisher-name {
    font-weight: 100;
    font-size: var(--font-size-sm);
    color: var(--color-text-light);
    margin: 2px 4px;
  }

  .publisher-logo {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
  }
</style>
